import request from '@/utils/request';
export const companyList = (params: any) =>
  request({
    url: 'user/companylist',
    method: 'get',
    params
  });
export const quitCompany = (data: any) =>
  request({
    url: 'Company/quit',
    method: 'DELETE',
    data
  });
export const setMainCompany = (params: any) =>
  request({
    url: 'User/company',
    method: 'get',
    params
  });
export const joinCompany = (data: any) =>
  request({
    url: 'User/company',
    method: 'POST',
    data
  });

export const getDepartmentList = (params: any) =>
  request({
    url: 'Company/departmentList',
    method: 'get',
    params
  });

export const getCustomerDepartmentList = (params: any) =>
  request({
    url: 'Company/getCustomerDeptList',
    method: 'get',
    params
  });

// 添加部门
export const addDepartment = (data: any) =>
  request({
    url: 'Company/department',
    method: 'POST',
    data
  });
  // 编辑部门
export const editorDepartment = (data: any) =>
  request({
    url: 'Company/department',
    method: 'PUT',
    data
  });
// 删除部门
export const delDepartment = (data: any) =>
  request({
    url: 'Company/department',
    method: 'DELETE',
    data
  });
  // 批量删除部门
export const batchDeleteDepartments = (data: any) =>
  request({
    url: 'Company/batchDeleteDepartments',
    method: 'DELETE',
    data
  });
  // 添加部门 人员列表
export const getNotInDeptUserList = (params: any) =>
  request({
    url: 'Company/getNotInDeptUserList',
    method: 'get',
    params
  });
  // 删除部门 人员列表
export const getDeptUserList = (params: any) =>
  request({
    url: 'Company/getDeptUserList',
    method: 'get',
    params
  });
  // 删除部门 人员
export const batchDelDeptUser = (data: any) =>
  request({
    url: 'Company/batchDelDeptUser',
    method: 'POST',
    data
  });

export const getCompanyInfo = (params: any) =>
  request({
    url: 'Company/company',
    method: 'get',
    params
  });
  // Company/customAddressList 自定义地址
export const getCustomAddressList = (params: any) =>
  request({
    url: 'Company/customAddressList',
    method: 'get',
    params
  });
export const createCompany = (data: any) =>
  request({
    url: 'Company/company',
    method: 'post',
    data
  });
export const getCompanyLimit = (params: any) =>
  request({
    url: 'Company/companyLimit',
    method: 'get',
    params
  });
export const freeLevel = (data: any) =>
  request({
    url: 'Company/freeLevel',
    method: 'put',
    data
  });
export const addServiceHomePage = (data: any) =>
  request({
    url: 'Company/serviceHomePage',
    method: 'post',
    data
  });
export const getServiceHomePage = (params: any) =>
  request({
    url: 'Company/serviceHomePage',
    method: 'get',
    params
  });
export const setOnlineToDraft = (data: any) =>
  request({
    url: 'Company/setOnlineToDraft',
    method: 'put',
    data
  });
